import axios from 'axios';
import logger from '../common/helpers/logger/logger';
import { SeoMetaComposerParams } from '../lib/propertyTypes';
import config from '../common/config';
import {
  USER_AGENT,
  SEO_META_COMPOSER_DATA,
} from '../common/helpers/constants';

export const makeSeoMetaComposerApiRequest = async (
  params: SeoMetaComposerParams,
  path: string,
) => {
  try {
    const response = await axios.post(
      config.seoMetaComposerUrl,
      {
        locale: SEO_META_COMPOSER_DATA.locale,
        site: SEO_META_COMPOSER_DATA.site,
        system: {
          siteName: SEO_META_COMPOSER_DATA.siteName,
          country: SEO_META_COMPOSER_DATA.country,
          currentMonthYear: getCurrentMonthYear(),
        },
        projectReviewDetails: {
          ...(params ?? {}),
        },
        path,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'User-Agent': USER_AGENT,
        },
      },
    );

    return response.data;
  } catch (error) {
    logger.logError(
      'seoMetaComposer.makeSeoMetaComposerApiRequest',
      'Error making Seo Meta Composer API request',
      {
        params,
        error: error?.message,
      },
    );

    throw error;
  }
};

export const fetchSeoMetaComposerData = async (
  path: string,
  seoMetaComposerRequestData: SeoMetaComposerParams,
) => {
  return await makeSeoMetaComposerApiRequest(seoMetaComposerRequestData, path);
};

const getCurrentMonthYear = () => {
  return new Date().toLocaleString('th-TH', {
    month: 'short',
    year: 'numeric',
  });
};
